export default __webpack_public_path__ + "img/maintenance.2e4c58da.png";